import { extend } from "vee-validate";
import { email, max_value, min_value, required, length } from "vee-validate/dist/rules";

extend("required", {
    ...required,
    message: (field) => `${field} cannot be blank.`
});
extend("email", email);
extend("length", length);
extend("min_value", min_value);
extend("max_value", max_value);
extend("min", {
    validate (value, { min }) {
        return value.length >= min;
    },
    params: ["min"],
    message: "{_field_} must be greater than {min} characters."
});
extend("max", {
    validate (value, { max }) {
        return value.length <= max;
    },
    params: ["max"],
    message: "{_field_} must be less than {max} characters."
});
extend("between-radius", {
    validate (value, { min, max }) {
        return Number(value) >= Number(min) && Number(value) <= Number(max);
    },
    params: ["min", "max"],
    message: "Radius must be between {min} and {max} Miles."
});
extend("between-numbers", {
    validate (value, { min, max }) {
        return Number(value) >= Number(min) && Number(value) <= Number(max);
    },
    params: ["min", "max"],
    message: "Number must be between {min} and {max}."
});
extend("password", {
    params: ["target"],
    validate (value, { target }) {
        return value === target;
    },
    message: "Password confirmation does not match"
});
extend("password-strong", {
    validate (value) {
        let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
        return strongRegex.test(value);
    },
    message: "The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character"
});
extend("ccnn", {
    validate (value) {
        let strongRegex = new RegExp("^([A-Za-z]{2}[0-9]{2})$");
        return strongRegex.test(value);
    },
    message: "Please enter in format CCNN where C - char and N - number."
});
extend("state", {
    validate (value, { length }) {
        let strongRegex = new RegExp(`^([A-Za-z]{${length}})$`);
        return strongRegex.test(value);
    },
    params: ["length"],
    message: `Please enter a {length} letter state abr.`
});
extend("county", {
    validate (value, { length }) {
        let strongRegex = new RegExp(`^([0-9]{${length}})$`);
        return strongRegex.test(value);
    },
    params: ["length"],
    message: `Please enter a {length} digits county code.`
});
extend("order-code", {
    validate (value) {
        let strongRegex = new RegExp("^([U][0-9]{11})$");
        return strongRegex.test(value);
    },
    message: "Please enter correct order id."
});
extend("compare-from-to", {
    params: ["target"],
    validate (value, { target }) {
        return Number(target) >= Number(value);
    },
    message: "'From' must be less than 'To' or equal"
});
extend("regexp", {
    validate (value, { regexp }) {
        let strongRegex = new RegExp(regexp);
        return strongRegex.test(value);
    },
    params: ["regexp"]
});
